module.exports = __webpack_public_path__ + "static/img/gyhlwsc-BlhdT1hS.2097ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/gyhlwsc-BlhdT1hS.png
// module id = 8JgW
// module chunks = 16